import { Print } from './print';
import { OperationMode } from './operation-mode';
import { ManufacturingOrder } from './manufacturing-order';

export class SchedulerTaskProgram {
  constructor(
    public hash?: string,
    public index?: number,
    public manufacturingOrderHash?: string,
    public manufacturingOrderCode?: string,
    public manufacturingOrderProjectNumber?: string,
    public materialHash?: string,
    public materialFileName?: string,
    public partHash?: string,
    public partName?: string,
    public programHash?: string,
    public programReference?: string,
    public programTime?: number,
    public programTimeDeviation?: number,
    public programTimeWithDeviation?: number,
    public operationHash?: string,
    public operationName?: string,
    public operationMode?: OperationMode,
    public printHash?: string,
    public printReference?: string,
    public printProjectNumber?: string,
    public print?: Print,
    public toolHash?: string,
    public toolName?: string,
    public toolHolderName?: string,
    public toolHolderHash?: string,
    public toolLength?: number,
    public crc?: number,
    public hasTwin?: boolean,
    public axle?: string,
    public pocket?: number,
    public observations?: string,
    public manufacturingOrder?: ManufacturingOrder,
    public sourceName?: string,
    public camWorker?: string,
    public camObservations?: string,
    public executed?: boolean,
    public opposite?: boolean
  ) { }

  get group() {
    return `
      ${ this.manufacturingOrderCode }
      ${ this.manufacturingOrderProjectNumber }
      ${ this.materialFileName }
      ${ this.printReference }
      ${ this.partName }
      ${ this.operationName }
    `;
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/scheduler-task-program.ts